import { Website } from '@/api/dashboard'

interface GetWebsiteUrlParams {
  website: Pick<Website, 'slug' | 'url' | 'share_token' | 'published_at'>
  /**
   * @description
   * - api: return the base URL of the website
   * - view: return the URL of the website with the share token and embedded flag
   * - edit: return the URL of the website with the preview flag
   */
  mode: 'api' | 'view' | 'edit'
  /**
   * Get the URL from the preview instance.
   */
  fromPreviewInstance?: boolean
  /**
   * @description
   * if provided, will be appended to the URL
   */
  pathname?: string
}

/**
 * Get the URL of the website.
 * @param websiteUrlParams
 * @returns
 */
export const getWebsiteUrl = ({ website, mode, fromPreviewInstance, pathname }: GetWebsiteUrlParams) => {
  const url = new URL(import.meta.env.DEV ? 'http://localhost:3001' : website.url)

  if (!website.published_at && window.location.hostname === 'dashboard.aghanim.com') {
    url.hostname = `${website.slug}.aghanim.app`
  }

  if (fromPreviewInstance) {
    if (import.meta.env.DEV) {
      throw new Error('Preview instance is not supported in development')
    }
    url.hostname = `${website.slug}.preview.aghanim.app`
  }

  if (mode === 'view') {
    url.searchParams.set('share_token', website.share_token)
    url.searchParams.set('embedded', 'true')
  }

  if (mode === 'edit') {
    url.searchParams.set('share_token', website.share_token)
    url.searchParams.set('preview', 'on')
    url.searchParams.set('embedded', 'true')
  }

  if (pathname) {
    url.pathname = pathname
  }

  return url.href.replace(/\/$/, '')
}
